export const laboratorioTituloTxt = "Visualiza, descargá y compartí tus estudios de laboratorio"